/* Static markup of the approved v5 homepage (03 Website Redesign/trip-ink-home-v5.html).
   "assets/<file>" paths are swapped for the 1Dash.Pro Media Storage URLs at mount (see data/tripinkAssets.ts). */
export const HOME_HTML = `
<style>
.ti-home .hrs-note a{color:var(--gold2);white-space:nowrap}
.ti-home .hrs-note{margin-top:.9em;font-size:.9em;color:#b9b4bd;line-height:1.5}
.ti-home .walkin-note{margin-top:.55em;font-size:.85em;color:#c8c2cf;letter-spacing:.03em}
</style>
<nav id="nav">
  <a class="logo" href="#top"><b class="neon">TRIP INK</b><small>TATTOO &middot; LAS VEGAS</small></a>
  <div class="links">
    <a href="#crew">The Crew</a><a class="opt" href="#vault">The Vault</a><a href="#lot">Up for Grabs</a><a class="opt" href="#days">How Many Days</a><a href="#how">Book</a><a href="#small">Small &amp; Piercing</a><a href="#show">The Show</a><a href="#faq">FAQ</a><a href="#visit">Visit</a>
  </div>
  <div class="navr">
    <a class="btn sm solid" href="#how" data-book>Book Your Full Day</a>
    <button class="burger" id="burger" aria-label="Menu">&#9776;</button>
  </div>
</nav>

<header class="hero" id="top">
  <svg class="sky" id="sky" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true"></svg>
  <div class="beam-up" aria-hidden="true"></div>
  <div class="stage-wrap" id="stageWrap" aria-hidden="true">
    <div class="stage" id="stage">
      <div class="kb">
        <picture>
          <source media="(max-width:700px)" srcset="assets/v3-hero-phone-1280.jpg">
          <img class="base" id="heroImg" src="assets/v3-hero-2560.jpg" srcset="assets/v3-hero-1600.jpg 1600w, assets/v3-hero-2560.jpg 2560w" sizes="112vw" alt="" fetchpriority="high">
        </picture>
        <video class="base vid" id="heroVid" muted loop playsinline preload="auto" poster="assets/v3-hero-2560.jpg" aria-hidden="true">
          <source src="assets/hero-sign-loop.mp4" type="video/mp4">
        </video>
        <div class="haze"><i></i><i></i><i></i></div>
        <div class="beam"></div>
        <div class="glow"></div>
        <div id="letters"></div>
        <svg class="sparks" id="sparks" viewBox="0 0 3136 1344" preserveAspectRatio="none">
          <defs><radialGradient id="sg"><stop offset="0" stop-color="#fff"/><stop offset=".35" stop-color="#fff3d6" stop-opacity=".9"/><stop offset="1" stop-color="#ffb070" stop-opacity="0"/></radialGradient></defs>
        </svg>
      </div>
    </div>
  </div>
  <div class="scrim"></div>
  <div class="vign"></div>
  <div class="grain" aria-hidden="true"></div>

  <div class="hero-copy" id="heroCopy">
    <div class="kicker"><i></i>Las Vegas, Nevada &middot; Hot Rod City</div>
    <h1><span class="l1">What happens in Vegas</span><span class="l2"><span>stays on your skin.</span></span></h1>
    <p class="lead">Book a <em>full day</em> with Las Vegas' top tattoo artists.</p>
    <p class="para">Seven artists. One front-row spot at the entrance of Hot Rod City. Pick your artist, lock your day, and leave with the piece you came for.</p>
    <div class="cta">
      <a class="btn solid" href="#how" data-book>Book Your Full Day <span class="arr">&rarr;</span></a>
      <a class="btn" href="tel:702-605-6633">Call Now</a>
    </div>
    <p class="walkin-note">Walk-ins welcome &middot; call to check availability</p>
    <div class="chips" aria-label="Shop highlights">
      <div class="pchip" style="--n:0"><span>7<small>Artists</small></span></div>
      <div class="pchip k" style="--n:1"><span class="wd">FULL<small>Day sessions</small></span></div>
      <div class="pchip p" style="--n:2"><span class="wd">OPEN<small>7 days</small></span></div>
      <div class="pchip g" style="--n:3"><span>4.9&#9733;<small>605 reviews</small></span></div>
      <div class="pchip w" style="--n:4"><span>LV<small>Hot Rod City</small></span></div>
    </div>
  </div>
</header>

<div class="ticker" aria-hidden="true"><div id="ticker"></div></div>
<div class="marq" aria-hidden="true"><div class="track" id="track"></div></div>

<section class="crew" id="crew">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Meet the house</span>
    <h2 class="title chrome lite">The Crew</h2>
    <p class="sub">Seven working artists, each with their own style. Find your person, then book their whole day.</p>
  </div>
  <div class="grid" id="crewGrid"></div>
  <div class="artist-strip rv">
    <div class="as-txt"><span class="eyebrow">For Trip Ink artists</span>
      <h3 class="chrome">Build your artist profile</h3>
      <p>A 10-minute interview: answer 12 quick questions by video, voice or text, then upload your best pieces, styles and open dates. It powers your page, your designs and the clients we send you.</p></div>
    <div class="as-cta"><a class="btn solid" href="/artist-interview">Start Your Interview</a></div>
  </div>
</section>

<div class="tube g rv" aria-hidden="true"><i class="ln l"></i>
  <svg viewBox="0 0 200 60"><path d="M0 30 C 30 30 40 30 60 30 C 72 30 78 8 100 8 C 122 8 128 30 140 30 C 160 30 170 30 200 30 M100 8 L 112 30 L 100 52 L 88 30 Z"/></svg>
  <i class="ln r"></i></div>

<section class="vault" id="vault">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Real work. Real skin.</span>
    <h2 class="title goldt lite">From the Trip Ink Vault</h2>
    <p class="sub">A few favorites from years of full days at the shop. Big color, black &amp; grey, horror and Japanese, healed and fresh.</p>
  </div>
  <div class="wall"><div class="vgrid" id="vgrid"></div></div>
  <p class="note rv">Pieces marked Rick Trip are his. The rest are shop work from the Trip Ink archive.</p>
</section>

<section class="lot" id="lot">
  <div class="head center rv">
    <span class="eyebrow">Fresh off the flash wall</span>
    <div class="bulbs"><h2 class="title neon lite">Up for Grabs</h2></div>
    <p class="sub">Design concepts waiting for a body. Claim one, and your artist will customize it to fit you.</p>
  </div>
  <div class="showme rv"><span class="badge">Show Me</span><p>Not sure yet? Tap <b>SHOW ME</b> on any design. See the artist, how to get the price and time, and a message from the artist. Then we text you more designs picked for your taste.</p></div>
  <div class="flash" id="flash"></div>
  <p class="note rv">Design concept, customized by your artist. Every piece is drawn to fit you.</p>
  <dialog class="sm-dlg" id="smDlg" aria-labelledby="smT"><button class="sm-x" id="smX" aria-label="Close">&times;</button><div class="sm-in" id="smIn"></div></dialog>
</section>

<div class="tube rv" aria-hidden="true"><i class="ln l"></i>
  <svg viewBox="0 0 200 60"><path d="M0 30 H 70 M 100 50 C 70 32 74 10 90 12 C 96 13 99 18 100 22 C 101 18 104 13 110 12 C 126 10 130 32 100 50 Z M130 30 H 200"/></svg>
  <i class="ln r"></i></div>

<section class="days" id="days">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Stack your days</span>
    <h2 class="title chrome lite">How Many Days?</h2>
    <p class="sub">Big work takes real hours. Each chip is one full day. Here is a rough guide to how many each kind of piece usually takes.</p>
  </div>
  <div class="rows" id="rows"></div>
  <div class="legend rv"><span><i></i>Typical</span><span><i class="m"></i>Could run longer</span></div>
  <p class="note rv">Every piece is different. Your artist confirms.</p>
</section>

<section class="reviews" id="reviews">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Don't take our word for it</span>
    <h2 class="title neon lite">605 Reviews. 4.9 Stars.</h2>
    <div class="stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
    <p class="sub">Real clients, real ink. Pulled live from our reviews.</p>
  </div>
  <div class="rev-frame rv">
    <iframe class="lc_reviews_widget" src="https://services.leadconnectorhq.com/reputation/widgets/review_widget/Fi48tOMs4jwRmKbTyIqY" frameborder="0" scrolling="no" style="min-width:100%;width:100%;border:0" title="Trip Ink Tattoo reviews"></iframe>
  </div>
</section>

<div class="tube g rv" aria-hidden="true"><i class="ln l"></i>
  <svg viewBox="0 0 200 60"><path d="M0 30 H 66 M 76 30 A 24 24 0 1 0 124 30 A 24 24 0 1 0 76 30 M 88 30 A 12 12 0 1 0 112 30 A 12 12 0 1 0 88 30 M134 30 H 200"/></svg>
  <i class="ln r"></i></div>

<section class="steps" id="how">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Three cards. One full day.</span>
    <h2 class="title neon lite">How Booking Works</h2>
  </div>
  <div class="grid">
    <div class="step rv"><span class="ix tl">1<i>&#9824;</i></span><span class="ix br">1<i>&#9824;</i></span><span class="pip" aria-hidden="true">&#9824;</span>
      <div class="inner"><h3>Request</h3><p>Tell us your artist, the idea, the placement, and send a photo of the skin. Takes a few minutes.</p></div></div>
    <div class="step red rv" style="--d:.18s"><span class="ix tl">2<i>&#9829;</i></span><span class="ix br">2<i>&#9829;</i></span><span class="pip" aria-hidden="true">&#9829;</span>
      <div class="inner"><h3>Consult &amp; deposit</h3><p>Your artist reviews it, talks through the design with you, and a deposit holds your day.</p><span class="ph">Deposit amount: to confirm</span></div></div>
    <div class="step red rv" style="--d:.36s"><span class="ix tl">3<i>&#9830;</i></span><span class="ix br">3<i>&#9830;</i></span><span class="pip" aria-hidden="true">&#9830;</span>
      <div class="inner"><h3>Your full day</h3><p>Show up ready. Your artist is all yours for the whole session, start to finish.</p></div></div>
  </div>
  <div class="jackpot rv">
    <div class="slot" id="slot" aria-hidden="true">
      <div class="reel"><div class="strip-r" style="--t:1.6s"></div></div>
      <div class="reel"><div class="strip-r" style="--t:2.1s"></div></div>
      <div class="reel"><div class="strip-r" style="--t:2.6s"></div></div>
      <span class="payline"></span>
      <button class="lever" id="lever" tabindex="-1" aria-hidden="true"></button>
    </div>
    <div class="jp-copy">
      <span class="eyebrow">Roll the dice?</span>
      <h3 class="chrome">No. Book your full day.</h3>
      <div class="cta" style="margin-top:0"><a class="btn solid" href="/book-now" data-book>Start Your Request <span class="arr">&rarr;</span></a></div>
    </div>
  </div>
</section>

<section class="small" id="small">
  <div class="head rv">
    <div class="bulbrow" data-n="7"></div>
    <span class="eyebrow">Not a full day?</span>
    <h2 class="title chrome lite">Small Tattoos &amp; Piercing</h2>
    <p class="sub">Little pieces and piercings have their own artists, so the full-day crew can stay on the big work.</p>
  </div>
  <div class="two">
    <div class="sp rv">
      <div class="bgi"><img src="assets/w-71221.jpg" alt="Fine line butterfly tattoo" loading="lazy"><img src="assets/w-71211.jpg" alt="Fine line yin-yang tattoo" loading="lazy"></div>
      <div class="in"><h3>Small Tattoos</h3><p>Fine line, minis, and first tattoos with Chris (@chrys.ink.tattoo).</p><a class="btn sm" href="/book-now?artist=chris" data-book>Book Chris</a></div>
    </div>
    <div class="sp rv" style="--d:.15s">
      <div class="bgi ring"><svg viewBox="0 0 100 100" fill="none" stroke="#ff8a85" stroke-width="3" stroke-linecap="round"><circle cx="50" cy="52" r="26"/><circle cx="50" cy="26" r="6" fill="#ff3b3f"/><circle cx="50" cy="52" r="34" stroke-opacity=".35"/></svg></div>
      <div class="in"><h3>Piercing</h3><p>Resident piercer Sophia Mae (@sophia_mae113) handles the jewelry side of the shop.</p><a class="btn sm" href="/book-now?artist=sophia" data-book>Book Sophia</a></div>
    </div>
  </div>
</section>

<section class="show" id="show">
  <div class="wrap">
    <div class="rv">
      <span class="badge">Coming Soon</span>
      <h2 class="title neon lite" style="margin-top:.3em">Trip Ink Tattoo Tours</h2>
      <p class="lede">A new show from Trip Ink about finding the right artist for the tattoo you want, starting right here in Las Vegas.</p>
      <div class="facts"><span>Air date: to be announced</span></div>
      <div class="cta" style="margin-top:0">
        <a class="btn solid" href="sms:702-605-6633?body=START">Join the Text List</a>
        <a class="btn" href="https://www.instagram.com/tripinktattoo/" target="_blank" rel="noopener">Follow on Instagram</a>
      </div>
      <p class="fine" style="margin-top:1em">Joins the Trip Ink text list. Msg &amp; data rates may apply. Reply STOP to opt out.</p>
    </div>
    <div class="reelwall rv" style="--d:.15s" aria-hidden="true">
      <div class="strip"><img src="assets/vault-rick-trip_horror_arm_01.jpg" alt="" loading="lazy"><img src="assets/vault-rick-trip_japanese_sleeve_01.jpg" alt="" loading="lazy"><img src="assets/vault-rick-trip_color-realism_back_01.jpg" alt="" loading="lazy"></div>
      <span class="play"></span>
      <div class="lbl"><b>Teaser coming soon</b><span class="tbc">Teaser reel: to confirm</span></div>
    </div>
  </div>
</section>

<section class="faq" id="faq">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Before you book</span>
    <h2 class="title chrome lite">Questions, Answered</h2>
  </div>
  <div class="wrap">
    <aside class="rickvid rv">
      <div class="scr"><img src="assets/vault-rick-trip_anime-pop_arm_01.jpg" alt="" loading="lazy"><span class="play" aria-hidden="true"></span></div>
      <div class="cap"><b>&ldquo;Hi, my name is Rick&hellip;&rdquo;</b><p>Rick walks you through the shop and answers the questions everyone asks. <span class="tbc">Video: to record</span></p></div>
    </aside>
    <div class="qa rv" style="--d:.1s" id="qa"></div>
  </div>
</section>

<section class="extras" id="extras">
  <div class="three">
    <div class="xcard gift rv">
      <div class="gcert" aria-hidden="true"><span>Trip Ink Tattoo Co. &middot; Las Vegas</span><i>Gift Certificate</i><b>FOR ONE GOOD TATTOO</b></div>
      <span class="eyebrow">Give it</span>
      <h3 class="goldt">Gift Certificates</h3>
      <p>For the person who has everything except the tattoo they keep talking about. Good toward a Trip Ink tattoo. <span class="tbc">Full-day gift amounts: to confirm</span></p>
      <div class="cta" style="margin-top:.4em"><a class="btn solid" href="/product/shop-gift-certificates">Buy a Gift Certificate</a><a class="btn" href="/shop">Shirts &amp; Merch</a></div>
    </div>
    <div class="xcard ev rv" style="--d:.12s">
      <div class="bg"><img src="assets/v4-halloween-rockhouse.jpg" alt="Halloween at the Rockhouse flyer, hosted by Trip Ink" loading="lazy"></div>
      <span class="badge">Event</span>
      <h3 class="neon">Halloween at the Rockhouse</h3>
      <p>Hosted by Trip Ink on the Las Vegas Strip. Step right up. Enter if you dare. <span class="tbc">Date, venue &amp; details: to confirm</span></p>
    </div>
    <div class="xcard club rv" style="--d:.24s">
      <div class="phone-ui" aria-hidden="true"><span class="b">START</span><span class="r">to (702) 605-6633</span></div>
      <span class="eyebrow">Stay in the loop</span>
      <h3 class="chrome">Text START</h3>
      <p>Text <b>START</b> to <b>(702) 605-6633</b> to join the Trip Ink text list. <span class="tbc">What the list sends: to confirm</span></p>
      <div class="cta" style="margin-top:.4em"><a class="btn solid" href="sms:702-605-6633?body=START">Text START</a></div>
      <p class="fine">Msg &amp; data rates may apply. Reply STOP to opt out. Not required to book.</p>
    </div>
  </div>
</section>

<footer class="visit" id="visit">
  <div class="bigname" aria-hidden="true">TRIP INK</div>
  <div class="head rv"><div class="bulbrow" data-n="7"></div><span class="eyebrow">Come find us</span><h2 class="title neon lite">Visit</h2></div>
  <div class="cols">
    <div class="rv">
      <h4>Address</h4>
      <div class="addr">5115 Dean Martin Drive #906<br>Las Vegas, NV 89118
        <small>Front entrance to Hot Rod City. Look for the red neon.</small></div>
      <div class="cta"><a class="btn sm solid" href="https://www.google.com/maps/search/?api=1&query=5115+Dean+Martin+Drive+906+Las+Vegas+NV+89118" target="_blank" rel="noopener">Get Directions</a></div>
    </div>
    <div class="rv contact" style="--d:.1s">
      <h4>Reach Us</h4>
      <a href="tel:702-605-6633"><b>CALL</b>702-605-6633</a>
      <a href="tel:702-586-5308"><b>WALK-IN</b>702-586-5308</a>
      <a href="sms:702-408-8305"><b>TEXT</b>702-408-8305</a>
      <a href="mailto:tripinklv@gmail.com"><b>EMAIL</b>tripinklv@gmail.com</a>
      <div class="social"><a class="btn sm" href="https://www.instagram.com/tripinktattoo/" target="_blank" rel="noopener">Instagram</a><a class="btn sm" href="https://www.facebook.com/tripinktattoo/" target="_blank" rel="noopener">Facebook</a></div>
    </div>
    <div class="rv" style="--d:.2s">
      <h4>Hours</h4>
      <ul><li><span>Mon &ndash; Wed</span><span>12pm &ndash; 8pm</span></li><li><span>Thu &ndash; Sun</span><span>1pm &ndash; 10pm</span></li></ul>
      <p class="hrs-note">Hours may vary. Call <a href="tel:702-586-5308">702-586-5308</a> to check availability.</p>
    </div>
  </div>
  <div class="copy"><span>&copy; Trip Ink Tattoo Company. Las Vegas, NV. &middot; <a href="/release-form">Release form</a> &middot; <a href="/shop">Shop</a> &middot; <a href="sms:702-605-6633?body=START">Text START to join our list</a> &middot; <a href="/artist-interview">Artists: profile interview</a></span></div>
</footer>

<nav class="actbar" aria-label="Quick actions"><a href="tel:702-605-6633">Call</a><a href="sms:702-408-8305">Text</a><a class="solid" href="#how" data-book>Book</a></nav>
`;
